import { render, staticRenderFns } from "./RestInput.vue?vue&type=template&id=2923aa12&"
import script from "./RestInput.vue?vue&type=script&lang=js&"
export * from "./RestInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports